import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  // No-op plugin since Teleport is built-in
})
